import { Controller } from 'react-hook-form';
import c from './controlled-link-details-list.module.scss';
import ItemDetails from '../../../../common/item-details/ItemDetails';
import { getPrimaryUrl } from '../../utils/get-primary-url';

const ControlledLinkDetailsList = ({ links, name, control }) => {
  return (
    <div className={c.links}>
      {links.map((link) => {
        const { id, name: linkName, status, isLoading, error, disabled } = link;
        return (
          <div key={id}>
            <Controller
              control={control}
              name={`${name}.${id}`}
              render={({ field: { onChange, value } }) => (
                <ItemDetails
                  title={linkName}
                  label={getPrimaryUrl(link)}
                  status={status}
                  checked={Boolean(value)}
                  handleCheck={onChange}
                  isLoading={isLoading}
                  error={error}
                  disabled={disabled}
                />
              )}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ControlledLinkDetailsList;
